module.exports = __webpack_public_path__ + "static/media/logo-플레이오니@3x.b03d63f8.png";